import * as i0 from '@angular/core';
import { Injectable, Pipe, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i7 from '@angular/forms';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import * as i3 from '@angular/material/autocomplete';
import { MatAutocompleteTrigger, MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i2 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i4 from '@angular/material/core';
import { MatRippleModule } from '@angular/material/core';
import * as i5 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i6 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i8 from '@angular/common';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

class EIPMultiSelectAutoCompleteService {
    constructor(http) {
        this.http = http;
    }
    getAutoCompleteList(body, apiURL, _headers) {
        return this.http.post(apiURL, body, { headers: _headers });
    }
}
EIPMultiSelectAutoCompleteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPMultiSelectAutoCompleteService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
EIPMultiSelectAutoCompleteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPMultiSelectAutoCompleteService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPMultiSelectAutoCompleteService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class MultiselectAcHelper {
    constructor() {
        this._selectedCount = 0;
    }
    setSelectedCount(count) {
        this._selectedCount = count;
    }
    setEmittingList(_tempList, _selValue) {
        let _emittingList = [];
        if (_tempList.length > 0) {
            _tempList.filter(element => {
                if (element.checked == true) {
                    _emittingList.push(element);
                }
            });
        }
        return _emittingList;
    }
    getSelectedItemsText(_emittingList) {
        let _selValue = '';
        if (_emittingList && _emittingList.length > 0) {
            _emittingList.filter(element => {
                if (element.checked) {
                    _selValue += element['text'] + '; ';
                }
            });
        }
        return _selValue;
    }
    filterTextIncludedList(_tempList, _selValue) {
        const _codeList = _tempList.filter(option => option.text.toLowerCase().includes(_selValue.toLowerCase().trim()));
        return _codeList;
    }
    filterTempList(_tempList, _selValue) {
        const _codeList = _tempList.filter(option => option.text.toLowerCase().includes(_selValue.toLowerCase().trim())).slice(0, 50);
        return _codeList;
    }
    filterExactTempList(_tempList, _selValue, _isValue) {
        let _codeList = {};
        if (!_isValue) {
            _codeList =
                _tempList.filter(option => option.text.toLowerCase().trim() == (_selValue.toLowerCase().trim()));
        }
        else if (_isValue) {
            _codeList =
                _tempList.filter(option => option.value.toLowerCase().trim() == (_selValue.toLowerCase().trim()));
        }
        return _codeList[0];
    }
    isExactMatchInList(_tempList, _selValue) {
        let _isExactMatch = false;
        if (_selValue && _tempList) {
            const _codeList = _tempList.filter(option => option.text.toLowerCase().trim() == (_selValue.toLowerCase().trim()));
            if (_codeList && _codeList.length > 0) {
                _isExactMatch = true;
            }
        }
        return _isExactMatch;
    }
    isIncludeInList(_tempList, _selValue) {
        let _isIncludeInList = false;
        const _codeList = _tempList.filter(option => option.text.toLowerCase().includes(_selValue.toLowerCase().trim())).slice(0, 50);
        if (_codeList && _codeList.length > 0) {
            _isIncludeInList = true;
        }
        return _isIncludeInList;
    }
    setCustomProperty(_tempList, _selectedItem, _isSelectItem) {
        if (_tempList && _tempList.length > 0) {
            _tempList.filter(element => {
                if (element.text.trim() == _selectedItem.text.trim() && element.value.trim() == _selectedItem.value.trim()) {
                    element.checked = !_isSelectItem;
                }
            });
        }
        return _tempList;
    }
    setSelectedItemsCount(_flag, _listLength, _selectFlag, _fullListFlag) {
        if (_flag == 'inc') {
            if (_selectFlag == 'all') {
                if (_listLength && _fullListFlag) {
                    this._selectedCount = _listLength;
                }
                else if (_listLength) {
                    this._selectedCount += _listLength;
                }
            }
            else {
                this._selectedCount++;
            }
        }
        else if (_flag == 'dec') {
            if (_selectFlag == 'all') {
                if (this._selectedCount >= _listLength) {
                    this._selectedCount -= _listLength;
                }
                else {
                    this._selectedCount = 0;
                }
            }
            else {
                this._selectedCount--;
            }
        }
    }
    getSelectedItemsCount() {
        if (isNaN(this._selectedCount)) {
            this._selectedCount = 0;
        }
        return this._selectedCount;
    }
    getSelectedItemsCountText() {
        return 'Selected Count : ' + this._selectedCount.toString();
    }
    initializeSelectedItemCount() {
        this._selectedCount = 0;
    }
    handleDefaultSelectedItems(_defaultSelectedValues, _tempList) {
        this._selectedCount = _defaultSelectedValues.length;
        if (_tempList.length > 0) {
            _tempList.filter(n => {
                _defaultSelectedValues.filter(selValue => {
                    if (n['value'] == selValue) {
                        n['checked'] = true;
                    }
                });
            });
        }
        return _tempList;
    }
    isItemsSelected(_codeListTemp) {
        let _isItemsSelected = false;
        for (let i = 0; i < _codeListTemp.length; i++) {
            if (_codeListTemp[i].checked == true) {
                _isItemsSelected = true;
                break;
            }
        }
        return _isItemsSelected;
    }
    getSelectedItems(_tempList) {
        let defaultSelectedItems = [];
        if (_tempList && _tempList.length > 0) {
            _tempList.filter(n => {
                if (n['checked'] == true) {
                    defaultSelectedItems.push(n);
                }
            });
        }
        return defaultSelectedItems;
    }
    isAllItemsSelected(_codeListTemp) {
        let _isAllItemsSelected = true;
        if (_codeListTemp) {
            if (_codeListTemp.length > 0) {
                for (let i = 0; i < _codeListTemp.length; i++) {
                    if (!_codeListTemp[i].checked) {
                        _isAllItemsSelected = false;
                        break;
                    }
                }
            }
            else {
                _isAllItemsSelected = false;
            }
        }
        else {
            _isAllItemsSelected = false;
        }
        return _isAllItemsSelected;
    }
}

class HighlightSearch {
    // transform(value: any, args: any): any {
    //     if (!args) { return value; }
    //     var re = new RegExp(args, 'gi'); //'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
    //     return value.replace(re, "<mark>" + args + "</mark>");
    // }
    // transform(value: any, args: any): any {
    //     if (!args) { return value; }
    //     var re = new RegExp(args, 'gi'); //'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
    //     return value.replace(re, match => {
    //         return `<span class="highlightText">${args}</span>`;
    //     });
    // }
    // transform(value: any, args: any): any {
    //   if (!args) { return value; }
    //   const re = new RegExp(args, 'gi'); // 'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
    //   return value.replace(re, match => {
    //       return `<span class="highlightText">${match}</span>` ;
    //   });
    transform(value, args) {
        if (!args) {
            return value;
        }
        // const invalid = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_-]+/g;
        const invalid = /[°()\[\]{}\\+*]+/g;
        const repl = args.replace(invalid, '');
        // console.log(repl);
        const re = new RegExp(repl, 'gi');
        //  const re = new RegExp(args, 'gi'); // 'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
        return value.replace(re, match => {
            return `<span class="highlightText">${match}</span>`;
        });
    }
}
HighlightSearch.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HighlightSearch, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
HighlightSearch.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HighlightSearch, name: "highlight" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HighlightSearch, decorators: [{
            type: Pipe,
            args: [{
                    name: 'highlight'
                }]
        }] });

class EIPMultiSelectAutoCompleteComponent {
    constructor(autoCompleteService) {
        this.autoCompleteService = autoCompleteService;
        this.myControl = new FormControl();
        this.codeList = [];
        this.codeListTemp = [];
        this.filetredVlueTemp = [];
        this.selValue = '';
        this.defaultScrollCount = 50;
        this.prevTextedValue = '';
        this.isOnChangeTriggered = false;
        this.isClicked = true;
        this.isDependentSelected = false;
        this.emittedValue = '';
        this.multiSelectAcHelper = new MultiselectAcHelper();
        this.isIncludeInList = false;
        this.emittedList = [];
        this.selCount = 0;
        this.selCountText = '';
        this.tempValues = '';
        this.isRecordsAvailable = true;
        this.dataList = [];
        this.showError = false;
        this.errorMessage = '';
        this.selectAllText = 'Select All';
        this.searchText = '';
        this.isPanelClosed = false;
        this.isReadOnly = false;
        this.optionStyles = '';
        this.previousDataSource = [];
        this.MinLength = 4;
        this.ShowTextValueField = 'Y';
        this.defaultValue = '';
        this.selectedIndex = -1;
        this.IsCascading = false;
        this.valueChange = new EventEmitter();
        this.clearValue = 'N';
        this.MaxLength = 250;
        this.defaultSelectedValues = [];
        this.isEmitOnSelect = 'N';
        this.isStaticDefaultSelection = false;
        this.isAllChecked = false;
        this.expandOptions = false;
        this.onclick = new EventEmitter();
        this.onblur = new EventEmitter();
    }
    ngOnInit() {
        this.selCount = this.multiSelectAcHelper.getSelectedItemsCount();
        this.selCountText = this.multiSelectAcHelper.getSelectedItemsCountText();
    }
    ngOnChanges() {
        let _isClearValue = false;
        let _isItemSelected = false;
        this.optionStyles = 'eipmultiautocompletestyle';
        _isItemSelected = this.multiSelectAcHelper.isItemsSelected(this.codeListTemp);
        // if (this.clearValue === 'Y') {
        //   this.multiSelectAcHelper.initializeSelectedItemCount();
        //   this.selCount = this.multiSelectAcHelper.getSelectedItemsCount();
        //   this.selCountText = this.multiSelectAcHelper.getSelectedItemsCountText();
        //   this.setAllItemsUnselected();
        //   this.clearValue = 'N';
        //   _isClearValue = true;
        //   this.emittedList = [];
        //   // return;
        // }
        if (this.dataSource) {
            if (!_isItemSelected || (JSON.stringify(this.previousDataSource) != JSON.stringify(this.dataSource))) {
                this.processMultiSelectList(this.dataSource, this.ShowTextValueField, this.ValueField, this.TextField);
                this.previousDataSource = this.dataSource;
                if (this.dataSource.length > 0) {
                    if (this.isAllChecked) {
                        this.selectAllText = 'Unselect All';
                        if (this.defaultSelectedValues.length === 0) {
                            this.setAllItemsSelected();
                            this.emitSelectedList();
                        }
                    }
                    else {
                        this.selectAllText = 'Select All';
                    }
                }
                else {
                    this.multiSelectAcHelper.setSelectedCount(0);
                    this.selCount = this.multiSelectAcHelper._selectedCount;
                    this.selCountText = 'Selected Count : ' + this.selCount;
                    this.selValue = '';
                    this.isAllChecked = false;
                    this.selectAllText = 'Select All';
                }
            }
        }
        else {
            if (this.ControlParameters && this.IsCascading) {
                // this.selCount = 0
                if (!_isItemSelected) {
                    this.multiSelectAcHelper.initializeSelectedItemCount();
                    this.selCountText = this.multiSelectAcHelper.getSelectedItemsCountText();
                    this.LoadList();
                }
                // this.showSelectedItemCount()
            }
            else if (!this.IsCascading) {
                if (this.codeListTemp && this.codeListTemp.length === 0 && this.ControlParameters) {
                    if (!_isItemSelected) {
                        this.LoadList();
                    }
                }
            }
        }
        if (this.defaultSelectedValues && this.defaultSelectedValues.length > 0 && this.dataSource) {
            if (this.isStaticDefaultSelection) {
                this.emittedList = [];
            }
            this.processMultiSelectList(this.dataSource, this.ShowTextValueField, this.ValueField, this.TextField, this.defaultSelectedValues);
        }
        if (this.expandOptions) {
            this.optionStyles = 'payment-terms-autocomplete eipmultiautocompletestyle';
        }
        if (this.clearValue === 'Y') {
            this.multiSelectAcHelper.initializeSelectedItemCount();
            this.selCount = this.multiSelectAcHelper.getSelectedItemsCount();
            this.selCountText = this.multiSelectAcHelper.getSelectedItemsCountText();
            this.setAllItemsUnselected();
            this.clearValue = 'N';
            _isClearValue = true;
            this.emittedList = [];
            // return;
        }
    }
    ngAfterViewInit() {
        if (this.autocompleteTrigger) {
            this.panelClosingActionSubscription = this.autocompleteTrigger.panelClosingActions.subscribe(x => {
                this.isPanelClosed = true;
                this.isReadOnly = false;
                if (this.autocompleteTrigger.activeOption) {
                }
                if (this.codeList.length === 1) {
                    this.selValue = this.codeList[0].text;
                }
                this.emitSelectedList();
                this.onblur.emit(this.setId);
            }, (error) => {
                this.isPanelClosed = true;
                console.log(error);
            }, () => {
                this.isPanelClosed = true;
            });
        }
    }
    onOptionSelected(event, _isOptionSelected, _optionValue) {
        event.stopPropagation();
        event.preventDefault();
        let _selectedText = '';
        let _selectedItem;
        let _availableText = this.selValue.trim();
        let _isOptionValue = false;
        // To handle incorrect selection between 2 items in autocomplete
        // if ((!this.isPanelClosed && this.autocompleteTrigger['_overlayAttached']) || (this.isEmitOnSelect == 'Y')) {
        if ((!this.isPanelClosed || this.autocompleteTrigger['_overlayAttached']) || (this.isEmitOnSelect === 'Y')) {
            // To set the selected value for searching and setting the selected item
            _selectedText = _optionValue;
            _isOptionValue = true;
            if (_selectedText && _selectedText.trim() !== '') {
                // Set Code list checked property to true / false based on condition
                _selectedItem = this.multiSelectAcHelper.filterExactTempList(this.codeListTemp, _selectedText.trim(), _isOptionValue);
                this.codeListTemp = this.multiSelectAcHelper.setCustomProperty(this.codeListTemp, _selectedItem, _isOptionSelected);
                // Retaining the code list after search and click of the option
                this.assignCollectionToCodeList(this.codeList);
                // Check box checked
                if (!_isOptionSelected) {
                    _availableText = _selectedText + '; ';
                    this.multiSelectAcHelper.setSelectedItemsCount('inc');
                    this.selValue += _availableText;
                    // To handle select all when all items are selected
                    // if ((this.codeListTemp.length == this.codeList.length) && (this.multiSelectAcHelper.isAllItemsSelected(this.codeListTemp))) {
                    const isSelectedAllItems = this.multiSelectAcHelper.isAllItemsSelected(this.codeListTemp);
                    if (isSelectedAllItems) {
                        this.selectAllText = 'Unselect All';
                        this.isAllChecked = true;
                    }
                    // this.emitSelectedList();
                }
                else if (_isOptionSelected) { // Check box Unchexked
                    // To handle select all when any one item is unselected
                    if (this.selectAllText == 'Unselect All' || this.isAllChecked) {
                        this.selectAllText = 'Select All';
                        this.isAllChecked = false;
                    }
                    _availableText = _availableText.replace(_selectedText + '; '.trim(), '');
                    this.multiSelectAcHelper.setSelectedItemsCount('dec');
                    this.selValue = _availableText;
                    //this.emitSelectedList();
                }
            }
            if (this.isEmitOnSelect === 'Y') {
                this.emitSelectedList();
            }
        }
        else if (!this.autocompleteTrigger['_overlayAttached']) {
            this.emitSelectedList();
        }
        this.selCountText = this.multiSelectAcHelper.getSelectedItemsCountText();
        this.selCount = this.multiSelectAcHelper.getSelectedItemsCount();
    }
    optionClicked(event, _isOptionSelected) {
        this.onOptionSelected(event, _isOptionSelected);
        this.defaultScrollCount = (this.defaultScrollCount === 0) ? 50 : this.defaultScrollCount;
        this.codeList = [];
        this.codeList = this.codeListTemp.slice(0, this.defaultScrollCount);
    }
    emitSelectedList() {
        let _emittingList = [];
        let emittingList = [];
        if (this.emittedList) {
            this.isPanelClosed = true;
            _emittingList = this.multiSelectAcHelper.setEmittingList(this.codeListTemp, this.selValue);
            this.selValue = this.multiSelectAcHelper.getSelectedItemsText(_emittingList);
            if (this.emittedList.length > 0) {
                if (JSON.stringify(this.emittedList) !== JSON.stringify(_emittingList)) {
                    this.emittedList = _emittingList;
                    this.performEmitting(_emittingList);
                }
            }
            else {
                if (JSON.stringify(this.emittedList) !== JSON.stringify(_emittingList)) {
                    this.emittedList = _emittingList;
                    this.performEmitting(_emittingList);
                }
            }
        }
    }
    performEmitting(_emittingList) {
        let emittingList = [];
        _emittingList.filter(element => {
            if (element.checked === true) {
                emittingList.push(element);
            }
        });
        this.multiSelectAcHelper.setSelectedCount(emittingList.length);
        this.selCountText = this.multiSelectAcHelper.getSelectedItemsCountText();
        this.selCount = this.multiSelectAcHelper.getSelectedItemsCount();
        // console.log('this.isAllChecked', this.isAllChecked );
        // emittingList['IsAllChecked'] = this.isAllChecked;
        const isAllcheckd = this.isAllChecked;
        this.valueChange.emit({ emittingList, isAllcheckd });
    }
    enter() {
        if (this.codeList.length === 1) {
            this.selValue = this.codeList[0].text;
            this.autocompleteTrigger.closePanel();
        }
    }
    assignCollectionToCodeList(codeList) {
        if (this.codeListTemp && this.codeListTemp.length > 0) {
            if (codeList && codeList.length > 0) {
                this.codeList = codeList.slice(0, 50);
            }
            else {
                this.defaultScrollCount = (this.defaultScrollCount === 0) ? 50 : this.defaultScrollCount;
                this.codeList = this.codeListTemp.slice(0, this.defaultScrollCount);
            }
        }
    }
    LoadList() {
        let _requestParams = {};
        let _headers = {};
        _requestParams = this.ControlParameters['params'];
        _headers = this.ControlParameters['headers'];
        if (_requestParams && _headers) {
            const subscriber$ = this.autoCompleteService.getAutoCompleteList(_requestParams, this.WebAPIUrl, _headers)
                .subscribe(result => {
                const CollectionResult = result.table || result;
                this.processMultiSelectList(CollectionResult, this.ShowTextValueField, this.ValueField, this.TextField, this.defaultSelectedValues);
                if (this.isAllChecked) {
                    this.selectAllText = 'Unselect All';
                    if (this.defaultSelectedValues.length === 0) {
                        this.setAllItemsSelected();
                        this.emitSelectedList();
                    }
                }
                else {
                    this.selectAllText = 'Select All';
                }
                if (subscriber$) {
                    subscriber$.unsubscribe();
                }
            }, (error) => {
                console.log(error);
                if (subscriber$) {
                    subscriber$.unsubscribe();
                }
            });
        }
    }
    clickEvent() {
        this.LoadList();
    }
    HandleSpecialCharacter() {
        let _isSplCharRemoved = false;
        let _originalValue;
        if (this.AllowSplChars === 'Y') {
            const strsplit = this.AllowedSplChars.split('~');
            let splchars = '[^A-Za-z0-9';
            let i = 0;
            for (i = 0; i < strsplit.length; i++) {
                splchars += '\\' + strsplit[i];
            }
            splchars += '\\' + '--';
            splchars = splchars + ']';
            const pattern = new RegExp(splchars);
            _originalValue = this.selValue;
            this.selValue = this.selValue.replace(pattern, '');
            if (_originalValue !== this.selValue) {
                _isSplCharRemoved = true;
            }
        }
        return _isSplCharRemoved;
    }
    change(event) {
        this.defaultScrollCount = 0;
        let filterValue = '';
        this.isRecordsAvailable = true;
        if (event) {
            filterValue = event;
            let _inputElement = document.getElementById(this.setId);
            filterValue = this.leftTrim(filterValue);
            _inputElement.value = filterValue;
            _inputElement.maxLength = this.MaxLength;
            filterValue = event.toLowerCase();
            if (filterValue.length > 0) {
                // let _inputElement = <HTMLInputElement>document.getElementById(this.setId);
                // filterValue = this.leftTrim(filterValue);
                // _inputElement.value = filterValue;
                // _inputElement.maxLength = this.MaxLength;
                this.filetredVlueTemp = this.codeListTemp.filter(option => option.text.toLowerCase().includes(filterValue));
                this.codeList = this.codeListTemp.filter(option => option.text.toLowerCase().includes(filterValue)).slice(0, 50);
                if (this.codeList && this.codeList.length > 0) {
                    this.isRecordsAvailable = true;
                    this.handleFilteredItems();
                }
                else {
                    this.isRecordsAvailable = false;
                }
                this.prevTextedValue = event;
            }
        }
        else {
            this.defaultScrollCount = (this.defaultScrollCount === 0) ? 50 : this.defaultScrollCount;
            this.codeList = this.codeListTemp.slice(0, this.defaultScrollCount);
            this.clearSearchText();
        }
    }
    autocompleteScroll() {
        this.onclick.emit(this.setId);
        // For styles
        const scrolldivelement = document.getElementById('multiSelect-autocompleteid');
        scrolldivelement.scrollTop;
        setTimeout(() => {
            if (this.statesAutocompleteRef &&
                this.autocompleteTrigger &&
                this.statesAutocompleteRef.panel) {
                this.autoCompleteScrollSubscription = fromEvent(this.statesAutocompleteRef.panel.nativeElement, 'scroll')
                    .pipe(map(x => this.statesAutocompleteRef.panel.nativeElement.scrollTop), takeUntil(this.autocompleteTrigger.panelClosingActions))
                    .subscribe(x => {
                    const scrollTop = this.statesAutocompleteRef.panel.nativeElement
                        .scrollTop;
                    const scrollHeight = this.statesAutocompleteRef.panel.nativeElement
                        .scrollHeight;
                    const elementHeight = this.statesAutocompleteRef.panel.nativeElement
                        .clientHeight;
                    const atBottom = scrollHeight === scrollTop + elementHeight;
                    if (atBottom) {
                        if (this.filetredVlueTemp.length > 0 && (!this.selCountText.includes('Selected Count : '))) {
                            this.codeList = [...this.codeList, ...this.filetredVlueTemp.slice(this.defaultScrollCount, this.defaultScrollCount + 50)];
                        }
                        else {
                            this.codeList = [...this.codeList, ...this.codeListTemp.slice(this.defaultScrollCount, this.defaultScrollCount + 50)];
                        }
                        this.defaultScrollCount = this.defaultScrollCount + 50;
                    }
                });
            }
        });
        // Set focus on search textbox
        setTimeout(() => this.searchInput.nativeElement.focus());
    }
    clearText() {
        this.tempValues = this.selCountText;
        this.selCountText = '';
        this.defaultScrollCount = (this.defaultScrollCount === 0) ? 50 : this.defaultScrollCount;
        this.codeList = this.codeListTemp.slice(0, this.defaultScrollCount);
        this.isPanelClosed = false;
        if (this.isAllChecked) {
            for (let i = 0; i < this.codeList.length; i++) {
                if (!this.codeList[i].checked) {
                    this.isAllChecked = false;
                    this.selectAllText = 'Select All';
                    break;
                }
            }
        }
        this.filetredVlueTemp = [];
        this.onclick.emit(this.setId);
    }
    setTextValues() {
        this.selCountText = this.multiSelectAcHelper.getSelectedItemsCountText();
        this.isReadOnly = false;
    }
    filterText(selectedText) {
        this.selValue = selectedText;
        const _isSplCharRemoved = this.HandleSpecialCharacter();
        let _selectedItem = {};
        let _isRecordsAvailable = true;
        let _inputElement = document.getElementById(this.setId);
        // selectedText = this.leftTrim(selectedText)
        _inputElement.value = selectedText;
        _isRecordsAvailable = this.multiSelectAcHelper.isIncludeInList(this.codeListTemp, selectedText);
        if (selectedText.length < this.MaxLength) {
            if (selectedText.trim() === '') {
                // _inputElement.value = selectedText.trim()
                this.codeList = this.codeListTemp.slice(0, 50);
            }
            else {
                if (this.multiSelectAcHelper.isExactMatchInList(this.codeListTemp, this.selValue.trim())) {
                    _selectedItem = this.multiSelectAcHelper.filterExactTempList(this.codeListTemp, this.selValue.trim());
                }
                this.codeList = this.multiSelectAcHelper.filterTempList(this.codeListTemp, selectedText);
            }
        }
        if (_isRecordsAvailable) {
            this.isRecordsAvailable = true;
        }
        else if (!_isRecordsAvailable) {
            this.isRecordsAvailable = false;
        }
    }
    leftTrim(_selectedText) {
        return _selectedText.replace(/^\s+/, '');
    }
    selectAll() {
        this.isAllChecked = !this.isAllChecked;
        if (this.isAllChecked) {
            this.selectAllText = 'Unselect All';
            this.setAllItemsSelected();
        }
        else if (!this.isAllChecked) {
            this.selectAllText = 'Select All';
            this.setAllItemsUnselected();
        }
    }
    setAllItemsSelected() {
        let _tempListLength = 0;
        if (this.filetredVlueTemp.length === 0) {
            _tempListLength = this.codeListTemp.length;
            this.multiSelectAcHelper.setSelectedItemsCount('inc', _tempListLength, 'all', 'fullList');
            this.selCountText = this.multiSelectAcHelper.getSelectedItemsCountText();
            this.codeListTemp.forEach(element => {
                element.checked = true;
                this.selValue += element.text + '; ';
            });
            this.codeList.forEach(element => {
                element.checked = true;
            });
        }
        else if (this.filetredVlueTemp.length > 0) {
            this.multiSelectAcHelper.setSelectedItemsCount('inc', this.filetredVlueTemp.length, 'all');
            this.selCountText = this.multiSelectAcHelper.getSelectedItemsCountText();
            this.selCount = this.multiSelectAcHelper.getSelectedItemsCount();
            if (this.codeList && this.codeList.length > 0) {
                this.codeList.forEach(element => {
                    element.checked = true;
                    this.selValue += element.text + '; ';
                });
            }
        }
        if (this.isEmitOnSelect === 'Y') {
            this.emitSelectedList();
        }
    }
    setAllItemsUnselected() {
        this.isAllChecked = false;
        let _listLength = 0;
        if (this.filetredVlueTemp.length > 0) {
            _listLength = this.filetredVlueTemp.length;
        }
        else {
            _listLength = this.codeListTemp.length;
        }
        this.multiSelectAcHelper.setSelectedItemsCount('dec', _listLength, 'all');
        this.selCountText = this.multiSelectAcHelper.getSelectedItemsCountText();
        this.selValue = '';
        if (this.filetredVlueTemp.length > 0) {
            this.codeList.forEach(element => {
                element.checked = false;
            });
        }
        else {
            this.codeListTemp.forEach(element => {
                element.checked = false;
            });
            this.codeList.forEach(element => {
                element.checked = false;
            });
        }
        if (this.isEmitOnSelect === 'Y') {
            this.emitSelectedList();
        }
    }
    handleFilteredItems() {
        let index = {};
        if (this.filetredVlueTemp) {
            index = this.filetredVlueTemp.find((item) => {
                return item.checked === false;
            });
        }
        if (!index) {
            this.selectAllText = 'Unselect All';
            this.isAllChecked = true;
        }
        else {
            this.selectAllText = 'Select All';
            this.isAllChecked = false;
        }
    }
    processMultiSelectList(_collectionResult, _showTextValue, _valueField, _textField, _defaultSelectedValues) {
        let _selCount = 0;
        if (_collectionResult && _collectionResult.length > 0) {
            if (_showTextValue === 'Y') {
                this.codeListTemp = _collectionResult.map((n) => ({
                    value: n[_valueField].toString().trim(),
                    text: n[_valueField].toString().trim() + ' - ' + n[_textField].toString().trim(),
                    desc: n[_textField].toString().trim(),
                    checked: false,
                    additionalValues: n
                }));
            }
            else if (_showTextValue === 'N') {
                this.codeListTemp = _collectionResult.map((n) => ({
                    value: n[_valueField].toString().trim(),
                    text: n[_textField].toString().trim(),
                    desc: n[_textField].toString().trim(),
                    checked: false,
                    additionalValues: n
                }));
            }
        }
        else {
            this.codeListTemp = [];
            this.codeList = [];
        }
        if (_defaultSelectedValues && _defaultSelectedValues.length >= 0) {
            this.codeListTemp = this.multiSelectAcHelper.handleDefaultSelectedItems(_defaultSelectedValues, this.codeListTemp);
            // this.multiSelectAcHelper.setSelectedCount(_defaultSelectedValues.length);
            if (this.codeListTemp.length > 0) {
                this.selValue = '';
                this.codeListTemp.forEach(_tmpItem => {
                    if (_tmpItem.checked) {
                        this.selValue += _tmpItem['desc'] + '; ';
                    }
                });
            }
            this.selCountText = this.multiSelectAcHelper.getSelectedItemsCountText();
            this.emitSelectedList();
        }
        this.assignCollectionToCodeList();
    }
    clearSearchText() {
        this.isReadOnly = true;
        this.isPanelClosed = false;
        this.searchText = '';
        this.filetredVlueTemp = [];
        const _isAllItemsSelected = this.multiSelectAcHelper.isAllItemsSelected(this.codeListTemp);
        if (!_isAllItemsSelected) {
            this.selectAllText = 'Select All';
            this.isAllChecked = false;
        }
        else {
            this.selectAllText = 'Unselect All';
            this.isAllChecked = true;
        }
        if (this.codeListTemp.length > 0) {
            this.assignCollectionToCodeList();
            this.isRecordsAvailable = true;
        }
        // else
        //   this.isRecordsAvailable = false;
        // Set focus on search textbox
        setTimeout(() => this.searchInput.nativeElement.focus());
    }
    ngOnDestroy() {
        if (this.panelClosingActionSubscription) {
            this.panelClosingActionSubscription.unsubscribe();
        }
        if (this.autoCompleteScrollSubscription) {
            this.autoCompleteScrollSubscription.unsubscribe();
        }
    }
}
EIPMultiSelectAutoCompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPMultiSelectAutoCompleteComponent, deps: [{ token: EIPMultiSelectAutoCompleteService }], target: i0.ɵɵFactoryTarget.Component });
EIPMultiSelectAutoCompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EIPMultiSelectAutoCompleteComponent, selector: "EIPMultiSelectAutoComplete", inputs: { WebAPIUrl: "WebAPIUrl", ControlParameters: "ControlParameters", TextField: "TextField", ValueField: "ValueField", AllowedSplChars: "AllowedSplChars", AllowSplChars: "AllowSplChars", WaterMarkText: "WaterMarkText", setId: "setId", PopulateOnLoad: "PopulateOnLoad", MinLength: "MinLength", collectionType: "collectionType", ShowTextValueField: "ShowTextValueField", defaultValue: "defaultValue", IsDisabled: "IsDisabled", selectedIndex: "selectedIndex", IsCascading: "IsCascading", clearValue: "clearValue", MaxLength: "MaxLength", dataSource: "dataSource", defaultSelectedValues: "defaultSelectedValues", isEmitOnSelect: "isEmitOnSelect", isStaticDefaultSelection: "isStaticDefaultSelection", isAllChecked: "isAllChecked", expandOptions: "expandOptions", ItemWidth: "ItemWidth" }, outputs: { valueChange: "valueChange", onclick: "onclick", onblur: "onblur" }, viewQueries: [{ propertyName: "searchInput", first: true, predicate: ["searchInput"], descendants: true }, { propertyName: "multiSelectSearch", first: true, predicate: ["multiSelectSearch"], descendants: true }, { propertyName: "statesAutocompleteRef", first: true, predicate: ["auto"], descendants: true }, { propertyName: "autocompleteTrigger", first: true, predicate: MatAutocompleteTrigger, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<mat-form-field class=\"example-full-width\">\r\n\r\n    <input\r\n    [disabled]=\"IsDisabled\"\r\n    type=\"text\"\r\n    class=\"mat-input-element\"\r\n    [placeholder]=\"WaterMarkText\"\r\n    [minlength]=\"MinLength\"\r\n    [(ngModel)]=\"selCountText\"\r\n    matInput\r\n    [matAutocomplete]=\"auto\"\r\n    (click)=\"clearSearchText()\"\r\n    [readonly]='isReadOnly'\r\n    [title]='selValue'\r\n    (blur)='setTextValues()'\r\n    (keydown.enter)='enter()'\r\n    (keydown)=\"clearSearchText()\"\r\n    id=\"multi-select-input-{{setId}}\"\r\n    >\r\n\r\n\r\n    <i\u00A0class=\"fa fa-caret-down float-right mr-1\"\u00A0style=\"position: absolute;right:0px;\"\r\n        (click)=\"isPanelClosed=false;\"></i>\r\n\r\n    <mat-autocomplete\r\n\r\n    #auto=\"matAutocomplete\"\r\n    [panelWidth]=\"ItemWidth\"\r\n    [class]=\"optionStyles\"\r\n    (opened)=\"autocompleteScroll()\"\r\n    id=\"multiSelect-autocompleteid\">\r\n        <mat-form-field class=\"example-full-width search-multiselect p-2 pt-1 \">\r\n            <input\r\n            #searchInput\r\n            [id]=\"setId\"\r\n            matInput\r\n            [(ngModel)]=\"searchText\"\r\n            (ngModelChange)='change($event)'\r\n            #multiSelectSearch>\r\n            <span matSuffix class=\"fa fa-search cursor-pointer\"></span>\r\n            <span matSuffix class=\" fa fa-times pl-1 pr-1 cursor-pointer\" (click)=\"clearSearchText()\"></span>\r\n        </mat-form-field>\r\n        <div *ngIf='isRecordsAvailable' class=\"eip-multiselect-search\">\r\n            <div class=\"eip-multiselect-option\">\r\n                <mat-option class=\"eip-multiselect\">\r\n                    <mat-checkbox *ngIf='isAllChecked' (click)='$event.stopPropagation(); selectAll()'\r\n                        [checked]='isAllChecked' class=\"eip-multiselect-checkbox\">\r\n                        {{selectAllText}}</mat-checkbox>\r\n\r\n                    <mat-checkbox *ngIf='!isAllChecked' (click)='$event.stopPropagation(); selectAll()'\r\n                        class=\"eip-multiselect-checkbox\">\r\n                        {{selectAllText}}</mat-checkbox>\r\n                </mat-option>\r\n\r\n                <mat-option class=\"eip-multiselect\" *ngFor=\"let option of codeList\" [title]='option.text'\r\n                    (click)=\"onOptionSelected($event, option.checked, option.value)\">\r\n                    <mat-checkbox\r\n                    *ngIf='option.checked'\r\n                    class=\"eip-multiselect-checkbox\"\r\n                    [id]='option.value'\r\n                    (click)=\"onOptionSelected($event, option.checked,  option.value)\"\r\n                    [checked]='option.checked'>\r\n                    <span [innerHTML]=\"option.text | highlight: searchText\"></span>\r\n                    </mat-checkbox>\r\n                    <mat-checkbox *ngIf='!option.checked' class=\"eip-multiselect-checkbox\" [id]='option.value'\r\n                        (click)=\"onOptionSelected($event, option.checked,  option.value)\">\r\n                        <span [innerHTML]=\"option.text | highlight: searchText\"></span>\r\n                    </mat-checkbox>\r\n                </mat-option>\r\n            </div>\r\n        </div>\r\n        <div *ngIf='!isRecordsAvailable'>\r\n            <mat-option>No Records found</mat-option>\r\n        </div>\r\n        <!-- </mat-select> -->\r\n    </mat-autocomplete>\r\n</mat-form-field>\r\n", styles: [".eip-multiselect-checkbox{width:100%!important;position:absolute;top:-5px}\n"], components: [{ type: i2.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: i3.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i4.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i5.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex", "aria-label", "aria-labelledby", "aria-describedby", "id", "required", "labelPosition", "name", "value", "checked", "disabled", "indeterminate"], outputs: ["change", "indeterminateChange"], exportAs: ["matCheckbox"] }], directives: [{ type: i6.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i7.MinLengthValidator, selector: "[minlength][formControlName],[minlength][formControl],[minlength][ngModel]", inputs: ["minlength"] }, { type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2.MatSuffix, selector: "[matSuffix]" }, { type: i8.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "highlight": HighlightSearch } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPMultiSelectAutoCompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'EIPMultiSelectAutoComplete', template: "<mat-form-field class=\"example-full-width\">\r\n\r\n    <input\r\n    [disabled]=\"IsDisabled\"\r\n    type=\"text\"\r\n    class=\"mat-input-element\"\r\n    [placeholder]=\"WaterMarkText\"\r\n    [minlength]=\"MinLength\"\r\n    [(ngModel)]=\"selCountText\"\r\n    matInput\r\n    [matAutocomplete]=\"auto\"\r\n    (click)=\"clearSearchText()\"\r\n    [readonly]='isReadOnly'\r\n    [title]='selValue'\r\n    (blur)='setTextValues()'\r\n    (keydown.enter)='enter()'\r\n    (keydown)=\"clearSearchText()\"\r\n    id=\"multi-select-input-{{setId}}\"\r\n    >\r\n\r\n\r\n    <i\u00A0class=\"fa fa-caret-down float-right mr-1\"\u00A0style=\"position: absolute;right:0px;\"\r\n        (click)=\"isPanelClosed=false;\"></i>\r\n\r\n    <mat-autocomplete\r\n\r\n    #auto=\"matAutocomplete\"\r\n    [panelWidth]=\"ItemWidth\"\r\n    [class]=\"optionStyles\"\r\n    (opened)=\"autocompleteScroll()\"\r\n    id=\"multiSelect-autocompleteid\">\r\n        <mat-form-field class=\"example-full-width search-multiselect p-2 pt-1 \">\r\n            <input\r\n            #searchInput\r\n            [id]=\"setId\"\r\n            matInput\r\n            [(ngModel)]=\"searchText\"\r\n            (ngModelChange)='change($event)'\r\n            #multiSelectSearch>\r\n            <span matSuffix class=\"fa fa-search cursor-pointer\"></span>\r\n            <span matSuffix class=\" fa fa-times pl-1 pr-1 cursor-pointer\" (click)=\"clearSearchText()\"></span>\r\n        </mat-form-field>\r\n        <div *ngIf='isRecordsAvailable' class=\"eip-multiselect-search\">\r\n            <div class=\"eip-multiselect-option\">\r\n                <mat-option class=\"eip-multiselect\">\r\n                    <mat-checkbox *ngIf='isAllChecked' (click)='$event.stopPropagation(); selectAll()'\r\n                        [checked]='isAllChecked' class=\"eip-multiselect-checkbox\">\r\n                        {{selectAllText}}</mat-checkbox>\r\n\r\n                    <mat-checkbox *ngIf='!isAllChecked' (click)='$event.stopPropagation(); selectAll()'\r\n                        class=\"eip-multiselect-checkbox\">\r\n                        {{selectAllText}}</mat-checkbox>\r\n                </mat-option>\r\n\r\n                <mat-option class=\"eip-multiselect\" *ngFor=\"let option of codeList\" [title]='option.text'\r\n                    (click)=\"onOptionSelected($event, option.checked, option.value)\">\r\n                    <mat-checkbox\r\n                    *ngIf='option.checked'\r\n                    class=\"eip-multiselect-checkbox\"\r\n                    [id]='option.value'\r\n                    (click)=\"onOptionSelected($event, option.checked,  option.value)\"\r\n                    [checked]='option.checked'>\r\n                    <span [innerHTML]=\"option.text | highlight: searchText\"></span>\r\n                    </mat-checkbox>\r\n                    <mat-checkbox *ngIf='!option.checked' class=\"eip-multiselect-checkbox\" [id]='option.value'\r\n                        (click)=\"onOptionSelected($event, option.checked,  option.value)\">\r\n                        <span [innerHTML]=\"option.text | highlight: searchText\"></span>\r\n                    </mat-checkbox>\r\n                </mat-option>\r\n            </div>\r\n        </div>\r\n        <div *ngIf='!isRecordsAvailable'>\r\n            <mat-option>No Records found</mat-option>\r\n        </div>\r\n        <!-- </mat-select> -->\r\n    </mat-autocomplete>\r\n</mat-form-field>\r\n", styles: [".eip-multiselect-checkbox{width:100%!important;position:absolute;top:-5px}\n"] }]
        }], ctorParameters: function () { return [{ type: EIPMultiSelectAutoCompleteService }]; }, propDecorators: { WebAPIUrl: [{
                type: Input
            }], ControlParameters: [{
                type: Input
            }], TextField: [{
                type: Input
            }], ValueField: [{
                type: Input
            }], AllowedSplChars: [{
                type: Input
            }], AllowSplChars: [{
                type: Input
            }], WaterMarkText: [{
                type: Input
            }], setId: [{
                type: Input
            }], PopulateOnLoad: [{
                type: Input
            }], MinLength: [{
                type: Input
            }], collectionType: [{
                type: Input
            }], ShowTextValueField: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], IsDisabled: [{
                type: Input
            }], selectedIndex: [{
                type: Input
            }], IsCascading: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], clearValue: [{
                type: Input
            }], MaxLength: [{
                type: Input
            }], dataSource: [{
                type: Input
            }], defaultSelectedValues: [{
                type: Input
            }], isEmitOnSelect: [{
                type: Input
            }], isStaticDefaultSelection: [{
                type: Input
            }], isAllChecked: [{
                type: Input
            }], expandOptions: [{
                type: Input
            }], onclick: [{
                type: Output
            }], onblur: [{
                type: Output
            }], ItemWidth: [{
                type: Input
            }], searchInput: [{
                type: ViewChild,
                args: ['searchInput', { static: false }]
            }], multiSelectSearch: [{
                type: ViewChild,
                args: ['multiSelectSearch', { static: false }]
            }], statesAutocompleteRef: [{
                type: ViewChild,
                args: ['auto', { static: false }]
            }], autocompleteTrigger: [{
                type: ViewChild,
                args: [MatAutocompleteTrigger, { static: false }]
            }] } });

class OrderBySearchPipe {
    // transform(value: any[], propertyName: string): any[] {
    //     if (propertyName)
    //         return value.sort((a: any, b: any) => b[propertyName].localeCompare(a[propertyName]));
    //     else
    //         return value;
    // }
    transform(records, args) {
        return records.sort(function (a, b) {
            if (a[args.property] < b[args.property]) {
                return -1 * args.direction;
            }
            else if (a[args.property] > b[args.property]) {
                return 1 * args.direction;
            }
            else {
                return 0;
            }
        });
    }
    ;
}
OrderBySearchPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: OrderBySearchPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
OrderBySearchPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: OrderBySearchPipe, name: "orderBy" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: OrderBySearchPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'orderBy',
                    pure: true
                }]
        }] });

class EIPPipe {
}
EIPPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPPipe, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EIPPipe.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPPipe, declarations: [HighlightSearch, OrderBySearchPipe], imports: [CommonModule], exports: [HighlightSearch, OrderBySearchPipe] });
EIPPipe.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPPipe, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPPipe, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HighlightSearch, OrderBySearchPipe],
                    imports: [CommonModule],
                    exports: [HighlightSearch, OrderBySearchPipe]
                }]
        }] });

class EIPMultiSelectAutoCompleteModule {
}
EIPMultiSelectAutoCompleteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPMultiSelectAutoCompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EIPMultiSelectAutoCompleteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPMultiSelectAutoCompleteModule, declarations: [EIPMultiSelectAutoCompleteComponent], imports: [CommonModule,
        FormsModule, ReactiveFormsModule, MatAutocompleteModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatRippleModule,
        HttpClientModule, MatCheckboxModule, EIPPipe], exports: [EIPMultiSelectAutoCompleteComponent] });
EIPMultiSelectAutoCompleteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPMultiSelectAutoCompleteModule, providers: [], imports: [[
            CommonModule,
            FormsModule, ReactiveFormsModule, MatAutocompleteModule,
            MatButtonModule,
            MatFormFieldModule,
            MatInputModule,
            MatRippleModule,
            HttpClientModule, MatCheckboxModule, EIPPipe
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPMultiSelectAutoCompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EIPMultiSelectAutoCompleteComponent],
                    imports: [
                        CommonModule,
                        FormsModule, ReactiveFormsModule, MatAutocompleteModule,
                        MatButtonModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatRippleModule,
                        HttpClientModule, MatCheckboxModule, EIPPipe
                    ],
                    providers: [],
                    exports: [EIPMultiSelectAutoCompleteComponent]
                }]
        }] });

/*
 * Public API Surface of eipmulti-select-auto-complete
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EIPMultiSelectAutoCompleteComponent, EIPMultiSelectAutoCompleteModule, EIPMultiSelectAutoCompleteService };
